export default __webpack_public_path__ + "static/media/aseel pic1.164d5b8a.jfif";